<div class="button-bar">
    <button class="default small icon fa fa-refresh" test-id="history.refresh.button" title="refresh" i18n-title="@@operating.history.button.refresh" (click)="refresh()"></button>
</div>
<clx-accordion>
    <clx-accordion-item *ngIf="showDatapointHistory" i18n-topic="@@operating.history.accordion.text.datapoint-history" topic="Datapoint history" state="opened" [attr.test-id]="'history.accordion.datapoint'">
        <history-list [url]="this.config.services.history.datapoint" id="datapoint-history" testId="history.grid.datapoint" #datapointHistory></history-list>
    </clx-accordion-item>
    <clx-accordion-item 
        *ngIf="showCommandHistory"
        i18n-topic="@@operating.history.accordion.text.command-history"
        topic="Command history" [attr.test-id]="'history.accordion.command'"
        [state]="(!showDatapointHistory) ? 'opened' : 'closed'"
    >
        <history-list [url]="this.config.services.history.command" id="command-history" testId="history.grid.command" #commandHistory></history-list>
    </clx-accordion-item>
</clx-accordion>
